import clsx from "clsx";
import BEmpty from "../BEmpty/BEmpty";
import BDocumentListItemView from "./BDocumentListItem";
import "./BDocumentList.scss";
import type { Document } from "types/document";

export type BDocumentListProps = {
  items: Document[];
  title?: string;
  emptyDescription?: string;
  className?: string;
};

const BDocumentList = ({
  items,
  title = "Tài liệu",
  emptyDescription = "Chưa có tài liệu",
  className,
}: BDocumentListProps) => {
  return (
    <div className={clsx("b-document-list", className)}>
      {title ? (
        <div className="b-document-list__header">
          <span className="b-document-list__title">{title}</span>
        </div>
      ) : null}

      {items.length === 0 ? (
        <BEmpty description={emptyDescription} />
      ) : (
        <ul className="b-document-list__list">
          {items.map((item) => (
            <BDocumentListItemView key={item.id} item={item} />
          ))}
        </ul>
      )}
    </div>
  );
};

export default BDocumentList;
